import styled from 'styled-components';
import { Text } from '@user-portal/wikr-components';

export const LinkText = styled(Text)<{ $withUnderline?: boolean; $center: boolean; $bold?: boolean }>`
    text-decoration: ${({ $withUnderline }) => ($withUnderline ? 'underline' : 'none')};
    ${({ $center }) => $center && `text-align: center;`};
    ${({ $bold }) => $bold && `font-weight: bold;`};
`;
